import AKSite from "../assets/images/ak-site.png";

const ak_portfolio = {
    slug: "Portfolio_Alexandre_Kotowicz_React",
    sections: [
        {
            elements: [
                { type: "title-prc", content: "Portfolio Alexandre Kotowicz" },
                { type: "tex-prc", content: "Développement d'un portfolio interactif pour un développeur de jeux vidéo en recherche d'emploi au Canada." },
                { type: "imageTitle", src: AKSite, alt: "Site web Portfolio Alexandre Kotowicz" }
            ]
        },
        {
            elements: [
                { type: "title", content: "Contexte du projet" },
                { type: "text", content: "Alexandre Kotowicz est un étudiant français résidant à Montréal, spécialisé dans le développement de jeux vidéo. En phase de recherche d'emploi au Canada, il avait besoin d'un portfolio professionnel pour mettre en valeur ses compétences et ses réalisations auprès des entreprises du secteur." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Analyse des besoins" },
                { type: "text", content: "Le besoin était clair : créer un site web capable de rassembler et présenter l'ensemble de ses projets (personnels, académiques, professionnels et techniques) dans un seul et même espace. Le portfolio devait être facilement navigable, visuellement attractif et refléter son expertise en développement de jeux vidéo." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Architecture du site" },
                { type: "text", content: "J'ai structuré le site pour offrir une navigation intuitive entre les différentes catégories de projets. Chaque projet bénéficie d'une page dédiée avec description détaillée, captures d'écran, vidéos de gameplay et liens vers les repositories ou versions jouables. L'architecture du site permet une consultation fluide et met en valeur la progression et la diversité des compétences d'Alexandre." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Développement avec React" },
                { type: "text", content: "Le portfolio a été développé avec React pour garantir une expérience utilisateur moderne et réactive. J'ai implémenté des animations subtiles, des transitions fluides et un système de filtrage des projets par catégorie. Le site est entièrement responsive et optimisé pour tous les types d'appareils." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Design et identité visuelle" },
                { type: "text", content: "Le design du site reflète l'univers du jeu vidéo tout en restant professionnel et épuré. La palette de couleurs et les éléments graphiques ont été choisis pour mettre en avant les projets sans détourner l'attention. Chaque section est pensée pour guider naturellement le regard vers les informations essentielles." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Impact professionnel" },
                { type: "text", content: "Ce portfolio a permis à Alexandre de présenter ses compétences de manière professionnelle lors de candidatures et d'entretiens d'embauche. Le site centralise toutes ses réalisations et facilite la découverte de son travail par les recruteurs. C'est devenu un outil essentiel dans sa démarche de recherche d'emploi au Canada." }
            ]
        }
    ]
};

export default ak_portfolio;